import API from '../../services/API';
import endpoints from '../../constants/configs/endpoints';
import { setError, startSpinner, stopSpinner } from '../../actions/common/actionCreators';
import { ADMIN_PROVISION_ACTION_TYPES } from '../../constants/actionTypes/adminProvisionActionTypes';
import {
    IAddNewAdminPrivilegesProps,
    IAddNewProvisioningRule,
    IProvisioningRules,
} from '../../modules/admin/provision/types/AdminProvision.interface';

const actions = { setError, startSpinner, stopSpinner };

export const setAdminPrivileges = data => ({
    type: ADMIN_PROVISION_ACTION_TYPES.SET_ADMIN_PRIVILEGES,
    payload: data,
});

export const updateFilteredProvisioningRules = (filteredProvisioningRules: IProvisioningRules[]) => ({
    type: ADMIN_PROVISION_ACTION_TYPES.UPDATE_FILTERED_PROVISIONING_RULES,
    payload: filteredProvisioningRules,
});

export const setApiErrorMsg = (isError: boolean) => ({
    type: ADMIN_PROVISION_ACTION_TYPES.SET_API_ERROR_MSG,
    payload: isError,
});

export const fetchAdminPrivilegesInfo = () => async dispatch => {
    const url = endpoints.ADMIN_PROVISION_PRIVILEGES;
    const privilegesData = await API.getData(url, dispatch, actions, true);

    if (privilegesData) {
        dispatch(setAdminPrivileges(privilegesData));
    } else {
        console.error('Cannot get admin privileges info', url);
    }
};

export const updateAdminPrivileges = (provisioningRule: IProvisioningRules) => async dispatch => {
    const url = endpoints.ADMIN_PROVISION_UPDATE_PRIVILEGES;
    const payload = {
        provisioning_rules: [
            {
                ...provisioningRule,
            },
        ],
    };

    try {
        const params = [url, payload, 'POST', true, undefined, 'application/json;charset=utf-8'];
        const data = await API.postData(params, dispatch, actions);
        if (data) {
            dispatch(setApiErrorMsg(false));
            return Promise.resolve(data);
        } else {
            dispatch(setApiErrorMsg(true));
            console.error('Cannot update admin privileges', url);
        }
    } catch (error) {
        dispatch(setApiErrorMsg(true));
        dispatch(stopSpinner());
        return Promise.reject(error);
    }
};

export const addNewAdminPrivileges =
    ({
        provisioningRoleLabel,
        managedRoleLabel,
        hasAllowCreate = false,
        hasAllowUpdate = false,
        provisioningRoleList,
        managedRoleList,
    }: IAddNewAdminPrivilegesProps) =>
        async dispatch => {
            const url = endpoints.ADMIN_PROVISION_UPDATE_PRIVILEGES;

            const selectedProvisioningRole = provisioningRoleList.find(role => role.label === provisioningRoleLabel)?.name ?? '';
            const selectedManagedRole = managedRoleList.find(role => role.label === managedRoleLabel)?.name ?? '';

            const payload: IAddNewProvisioningRule = {
                provisioning_rules: [
                    {
                        active: true,
                        allow_add: hasAllowCreate,
                        allow_update: hasAllowUpdate,
                        managed_role: selectedManagedRole,
                        managed_role_label: managedRoleLabel,
                        provisioning_role: selectedProvisioningRole,
                        provisioning_role_label: provisioningRoleLabel,
                    },
                ],
            };

            try {
                const params = [url, payload, 'POST', true, undefined, 'application/json;charset=utf-8'];
                const data = await API.postData(params, dispatch, actions);
                if (data) {
                    dispatch(fetchAdminPrivilegesInfo());
                    dispatch(setApiErrorMsg(false));
                } else {
                    dispatch(setApiErrorMsg(true));
                    console.error('Cannot update admin privileges', url);
                }
            } catch (error) {
                dispatch(setApiErrorMsg(true));
                dispatch(stopSpinner());
                return Promise.reject(error);
            }
        };
